import { useTrackChanges } from '../hooks'
import { SavedCountryCode } from '../storage'
import { Combobox } from 'src/components/Shared/UIComponents/Combobox'
import { ReactNode } from 'react'

type Props = {
  savedStorage: SavedCountryCode
  initialValue: string
  title: string
  tooltip?: ReactNode
} & Omit<Parameters<typeof Combobox>[0], 'value' | 'setValue'>

export function TrackedCountryCodeField({
  savedStorage,
  initialValue,
  tooltip,
  ...rest
}: Props) {
  const [value, setValue] = savedStorage.useState(initialValue)
  useTrackChanges(rest.title, initialValue, value, setValue)

  return (
    <Combobox value={value} tooltip={tooltip} setValue={setValue} {...rest} />
  )
}
